import React, { useState } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import logo from '../../assets/images/UPG_site_logo.png';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {UpdateProfile} from '../../API/auth'
import badminton from '../../assets/images/Login_Register_Carousel/carousel_badminton.jpg';
import tt from '../../assets/images/Login_Register_Carousel/carousal_table_tennis.jpg';
import bowling from '../../assets/images/Login_Register_Carousel/carousel_bowling.jpg';

// import badminton from '../../assets/images/sliders/Badminton.jpg';
// import tt from '../../assets/images/sliders/tt1.jpg'; 
// import bowling from '../../assets/images/sliders/bowling.jpg';
import running from '../../assets/images/sliders/running.jpg';

import ArrowIcon from '../../components/icons/ArrowIcon'

import badminton_new from '../../assets/images/Login_Register_Carousel/Badminton_new.jpg';
import tt_new from '../../assets/images/Login_Register_Carousel/carousal_table_tennis_new.jpg';

function Login({ children }) {
  const navigate = useNavigate();
  const location = useLocation(); 

  const [showPassword, setShowPassword] = useState(false);
  // const [SliderImages, setSliderImages] = useState([badminton, tt, running, bowling]);
  const [SliderImages, setSliderImages] = useState([badminton, tt, badminton_new, tt_new]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  const SliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,          // Enable auto play
    autoplaySpeed: 2000,
    accessibility: true,   // Keyboard Navigation
  };


  const handleBack = async (home = null) => {
    console.log("home",home)
    console.log(location.pathname)
    if (location.pathname == '/game-plan') {
      console.log("slot can be reset")
      let formDataTeam = {
        "reset" : true,
      }
      let resetTeam = await UpdateProfile(formDataTeam)
      if (resetTeam.data.status) {
        if (home != null) {
          window.location.href = '/'
        } else {
          navigate(-1); // Go back to the previous page

        }

      }
    } else {

      navigate(-1); // Go back to the previous page
    }
  };

  return (
    <>
      <div className='h-100 main-box'>
        <section className='login-form'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-sm-6 text-white h-100 overflow-auto scroll-none'>
                <div className='mt-2 text-dark' >
                  <button className='navigate_arrow_btn' onClick={() => handleBack()}>
                    <i class="bi bi-arrow-left fs-5 me-1"></i> Go Back
                  </button>

                </div>
                <a className="navbar-brand" onClick={() => {location.pathname == '/game-plan' ? handleBack(true) : window.location.href='/'}}>
                  <img src={logo} alt='logo' className='mx-5 mt-2 logo form_cpl_logo_mobile' />
                </a>
                <div className='row justify-content-center form-row'>
                  <div className='col-md-8'>
                    <div className='py-5'>
                      {children}
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-sm-6 px-0 d-none d-sm-block position-relative'>
                {/* <div className='slider-custom-arrow position-absolute top-0 end-0 z-index-9 rounded-circle text-center mt-4 me-4 cursor-pointer'><ArrowIcon />
                </div> */}
                <Slider {...SliderSettings}>
                  {
                    SliderImages.length ? SliderImages.map((item, index) => (
                      <div className='vh-100'>
                        <div className='form-side-bg vh-100' style={{ backgroundImage: `url(${item})` }}></div>
                      </div>
                    )) : ''
                  }
                </Slider>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
export default Login
